import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M9 16C9.85217 16 10.2974 15.0145 9.78323 14.3775L9.70711 14.2929L7.41603 12.0007C8.68529 10.7976 10.6983 10 13 10C16.9183 10 20 12.3113 20 15C20 15.5523 20.4477 16 21 16C21.5523 16 22 15.5523 22 15C22 11.0613 17.9183 8.00001 13 8.00001C10.1933 8.00001 7.65905 8.99694 6.00031 10.585L3.70711 8.2929C3.10453 7.69032 2.09282 8.07234 2.00598 8.88637L2 9.00001V15C2 15.5128 2.38604 15.9355 2.88338 15.9933L3 16H9Z" />,
  'Undo'
);
